import { render } from "./CategoriesSectionHome.vue?vue&type=template&id=6ed977ea&scoped=true"
import script from "./CategoriesSectionHome.vue?vue&type=script&lang=js"
export * from "./CategoriesSectionHome.vue?vue&type=script&lang=js"

import "./CategoriesSectionHome.vue?vue&type=style&index=0&id=6ed977ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed977ea"]])

export default __exports__